/**
 * ============================================================================
 * TRANSIENT: Appointment Config Page (appointment-config-page)
 * Type: poc
 * Amplitude key: none
 * End date: 2026-12-31
 * PR: #TODO_AFTER_PR_CREATION_appointment-config-page
 * ============================================================================
 */

import { Box, Tab, Tabs } from '@evaneos/b2b-ui';

import type { AppointmentTab } from '../useAppointment';

type Props = {
    activeTab: AppointmentTab;
    isConnected: boolean;
    onTabChange: (tab: AppointmentTab) => void;
};

export const AppointmentPageHeaderPartial = ({
    activeTab,
    isConnected,
    onTabChange,
}: Props): JSX.Element => (
    <Box
        sx={{
            bgcolor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
            px: 4,
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
        }}
    >
        <Tabs
            value={activeTab}
            onChange={(_, v) => onTabChange(v as AppointmentTab)}
            sx={{ '& .MuiTab-root': { textTransform: 'none', fontSize: 14 } }}
        >
            <Tab
                data-spec-id="agenda-tab-rendez-vous"
                value="rendez-vous"
                label="Mes rendez-vous"
                disabled={!isConnected}
                className={activeTab === 'rendez-vous' ? 'tab--active' : ''}
            />
            <Tab
                data-spec-id="agenda-tab-disponibilites"
                value="disponibilites"
                label="Mes disponibilités"
                disabled={!isConnected}
                className={activeTab === 'disponibilites' ? 'tab--active' : ''}
            />
        </Tabs>
    </Box>
);
